class customBundle {
  steps = {
    1: { product_id: null, variant_id: null, image: null, title: null, price: null, subscription: null },
    2: { product_id: null, variant_id: null, image: null, title: null, price: null, subscription: null },
    3: { product_id: null, variant_id: null, image: null, title: null, price: null, subscription: null },
    4: { selected: null }
  }

  STEP_SELECTOR = '.step-item';
  STEP_1_SELECTOR = '.step-item-1 .options input';
  STEP_2_SELECTOR = '.step-item-2 .product-card';
  STEP_3_SELECTOR = '.step-item-3 .product-card';
  CARD_SELECTOR = '.product-card';
  STEP_4_SELECTOR = '.step-item-4 .option';
  STEP_4_CARD = '.option';
  RESULT_SELECTOR = '.result-block.step-%-result';
  INDICATOR_SELECTOR = '.step-%-indicator';
  ACTIVE_CLASS = 'active';
  ERROR_CLASS = 'error';
  ORIG_PRICE_SELECTOR = '.buy-button-block .orig-price';
  NEW_PRICE_SELECTOR = '.buy-button-block .price';
  BUTTON_SELECTOR = 'button.add-bundle-to-cart';
  CART_ERROR_SELECTOR = '.bundle-cart-error';

  constructor () {
    this.getCurrentInfo();
    this.updateStep1StockStatus();
    this.connectStep1();
    this.connectStep2Events();
    this.connectStep3Events();
    this.connectStep4Events();
    this.connectButton();
  }

  connectStep1() {
    document.querySelectorAll(this.STEP_1_SELECTOR).forEach((item) => {
      item.addEventListener('change', this.onStep1OptionChange.bind(this));
    });
  }

  arrEq(a,b) {
    return a.length === b.length && a.every((val, index) => val === b[index]);
  }

  getCurrentInfo() {
    this.updateStep1SelectedValues();
    let selected = document.querySelectorAll(this.STEP_1_SELECTOR+':checked');
    if (selected) {
      let checkedOption = [];
      selected.forEach((option) => {
        checkedOption.push(option.value);
      });
      let mainObj = this;

      window.bundleData.step_1.product.variants.forEach((variant) => {
        if (mainObj.arrEq(variant.options,checkedOption)) {
          mainObj.steps['1'].variant_id = variant.id;
          mainObj.steps['1'].image = variant.image;
          mainObj.steps['1'].price = variant.price;
          mainObj.steps['1'].product_id = window.bundleData.step_1.product.id;
          mainObj.steps['1'].title = window.bundleData.step_1.product.title;
          return;
        }
      });
      this.changeStepInfo(1);
    }
  }

  onStep1OptionChange(e) {
    this.getCurrentInfo();
    this.switchVariantSlider();
    this.updateStep1StockStatus();
  }

  updateStep1StockStatus() {
    const label = document.querySelector('.step-item-1 .bundle-stock-label');
    if (!label) return;

    if (!window.bundleVariantAvailability) {
      label.textContent = '';
      label.classList.remove('show');
      return;
    }

    const checkedOptions = [...document.querySelectorAll('.step-item-1 .swatch-input:checked')]
      .map(input => input.value);

    if (!checkedOptions.length) {
      label.textContent = '';
      label.classList.remove('show');
      return;
    }

    const key = checkedOptions.join('|');
    const isAvailable = window.bundleVariantAvailability[key];

    if(isAvailable === false) {
      label.textContent = 'Out of stock';
      label.classList.add('show');
    }else {
      label.textContent = '';
      label.classList.remove('show');
    }
  }

  switchVariantSlider() {
    const productMedia = document.querySelector('.product-media[data-bundle-color-name]');
    if (!productMedia) return;

    const optName = productMedia.dataset.bundleColorName;
    const colorInput = document.querySelector(`.step-item-1 input[name="${optName}"]:checked`);
    if (!colorInput) return;

    const colorValue = colorInput.value;
    const colorHandle = colorValue.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();

    document.querySelectorAll('.bundle-color-slider').forEach(slider => {
      const isMatch = slider.dataset.colorHandle === colorHandle;
      slider.style.display = isMatch ? '' : 'none';

      if (isMatch && window.bundleSliders && window.bundleSliders[colorHandle]) {
        const { swiperMain, swiperThumbs } = window.bundleSliders[colorHandle];
        if (swiperMain) {
          swiperMain.update();
          swiperMain.slideTo(0, 0);
        }
        if (swiperThumbs) swiperThumbs.update();
      }
    });
  }

  updateStep1SelectedValues() {
    document.querySelectorAll('.step-item-1 .option').forEach((optionEl) => {
      const checkedInput = optionEl.querySelector('.swatch-input:checked');
      if (!checkedInput) return;
      const selectedValueEl = optionEl.querySelector('.selected-value');
      if (selectedValueEl) selectedValueEl.textContent = checkedInput.value;
    });
  }

  connectStep2Events() {
    document.querySelectorAll(this.STEP_2_SELECTOR).forEach((elem) => {
      elem.addEventListener('click',this.connectStep2.bind(this));
    });
  }

  connectStep3Events() {
    document.querySelectorAll(this.STEP_3_SELECTOR).forEach((elem) => {
      elem.addEventListener('click',this.connectStep3.bind(this));
    });
  }

  connectStep4Events() {
    document.querySelectorAll(this.STEP_4_SELECTOR).forEach((elem) => {
      elem.addEventListener('click',this.connectStep4.bind(this));
    });
  }

  connectStep2(e) {
    let selected = document.querySelector(this.STEP_2_SELECTOR+'.'+this.ACTIVE_CLASS);
    if (selected) {
      selected.classList.remove(this.ACTIVE_CLASS);
    }

    let target = e.target.closest(this.CARD_SELECTOR);
    target.classList.add(this.ACTIVE_CLASS);
    let prodId = target.getAttribute('data-product');
    let mainObj = this;

    window.bundleData.step_2.products.forEach((product,index) => {
      if (product.id*1 === prodId*1) {
        mainObj.steps['2'].product_id = product.id;
        mainObj.steps['2'].variant_id = product.variant_id;
        mainObj.steps['2'].image = product.image;
        mainObj.steps['2'].title = product.title;
        mainObj.steps['2'].price = product.price;
        mainObj.steps['2'].index = index;
        if (mainObj.steps['4'].selected !== null) {
          product.selling_plans.forEach((plan) => {
            if (plan.name.includes(mainObj.steps['4'].selected)) {
              mainObj.steps['2'].subscription = plan.id;
              return;
            }
          });
        }
      }
    });
    this.changeStepInfo(2);
    this.clearCartError();
  }

  connectStep3(e) {
    let selected = document.querySelector(this.STEP_3_SELECTOR+'.'+this.ACTIVE_CLASS);
    if (selected) {
      selected.classList.remove(this.ACTIVE_CLASS);
    }
    let target = e.target.closest(this.CARD_SELECTOR);
    target.classList.add(this.ACTIVE_CLASS);
    let prodId = target.getAttribute('data-product');
    let mainObj = this;
    window.bundleData.step_3.products.forEach((product,index) => {
      if (product.id*1 === prodId*1) {
        mainObj.steps['3'].product_id = product.id;
        mainObj.steps['3'].variant_id = product.variant_id;
        mainObj.steps['3'].image = product.image;
        mainObj.steps['3'].title = product.title;
        mainObj.steps['3'].price = product.price;
        mainObj.steps['3'].index = index;
        if (mainObj.steps['4'].selected !== null) {
          product.selling_plans.forEach((plan) => {
            if (plan.name.includes(mainObj.steps['4'].selected)) {
              mainObj.steps['3'].subscription = plan.id;
              return;
            }
          });
        }
      }
    });
    this.changeStepInfo(3);
    this.clearCartError();
  }

  connectStep4(e) {
    let selected = document.querySelector(this.STEP_4_SELECTOR+'.'+this.ACTIVE_CLASS);
    if (selected) {
      selected.classList.remove(this.ACTIVE_CLASS);
    }

    let target = e.target.closest(this.STEP_4_CARD);
    target.classList.add(this.ACTIVE_CLASS);
    let mainObj = this;
    mainObj.steps['4'].selected = target.getAttribute('data-selected');

    if (this.steps['2'].product_id !== null) {
      window.bundleData.step_2.products.forEach((product) => {
        if (product.id * 1 === mainObj.steps['2'].product_id * 1) {
          if (mainObj.steps['4'].selected !== null) {
            product.selling_plans.forEach((plan) => {
              if (plan.name.includes(mainObj.steps['4'].selected)) {
                mainObj.steps['2'].subscription = plan.id;
                return;
              }
            });
          }
        }
      });
    }

    if (this.steps['3'].product_id !== null) {
      window.bundleData.step_3.products.forEach((product) => {
        if (product.id * 1 === mainObj.steps['3'].product_id * 1) {
          if (mainObj.steps['4'].selected !== null) {
            product.selling_plans.forEach((plan) => {
              if (plan.name.includes(mainObj.steps['4'].selected)) {
                mainObj.steps['3'].subscription = plan.id;
                return;
              }
            });
          }
        }
      });
    }
    this.changeStepInfo(4);
  }

  changeStepInfo(num) {
    const block = document.querySelector(this.RESULT_SELECTOR.replace('%', num));
    const indicator = document.querySelector(this.INDICATOR_SELECTOR.replace('%', num));

    if (!block) return;
    if (indicator) indicator.classList.add(this.ACTIVE_CLASS);

    const step = this.steps[num.toString()];

    switch (num) {
      case 1:
      case 2:
      case 3: {
        if (step.product_id !== null) {
          const imageBlock = block.querySelector('.image-block');
          const titleEl = block.querySelector('.title .product');
          if (imageBlock) {
            const img = document.createElement('img');
            img.src = step.image || '';
            img.alt = step.title || '';
            imageBlock.innerHTML = '';
            imageBlock.appendChild(img);
          }
          if (titleEl) titleEl.textContent = step.title || '';
          block.classList.add('included');
        }
        break;
      }
      case 4: {
        const titleEl = block.querySelector('.title .product');
        if (titleEl) titleEl.textContent = step.selected || '';
        block.classList.add('included');
        break;
      }
    }

    this.updatePrice();
  }

  updatePrice(){
    let price = 0;
    if (this.steps['1'].product_id !== null) {
      price += this.steps['1'].price*1;
    }
    if (this.steps['2'].product_id !== null) {
      price += this.steps['2'].price*1;
    }
    if (this.steps['3'].product_id !== null) {
      price += this.steps['3'].price*1;
    }
    let priceBlock = document.querySelector(this.ORIG_PRICE_SELECTOR);
    if (priceBlock) {
      priceBlock.innerHTML = '$ '+(price/100);
    }
    priceBlock = document.querySelector(this.NEW_PRICE_SELECTOR);
    if (priceBlock) {
      let discount = window.bundleData.discount ?? 0;
      priceBlock.innerHTML = '$ '+(Math.round(price*(1-discount/100))/100);
    }
    this.updateButtonState();
  }

  connectButton() {
    const btn = document.querySelector(this.BUTTON_SELECTOR);
    btn.disabled = true;
    btn.addEventListener('click', this.addToCart.bind(this));
  }

  isAllSelected() {
    return (
      this.steps['1'].variant_id !== null &&
      this.steps['2'].variant_id !== null &&
      this.steps['3'].variant_id !== null &&
      this.steps['4'].selected !== null
    );
  }

  updateButtonState() {
    const btn = document.querySelector(this.BUTTON_SELECTOR);
    if (btn) {
      btn.disabled = !this.isAllSelected();
    }
  }

  showCartError(message) {
    const btn = document.querySelector(this.BUTTON_SELECTOR);
    const errorEl = document.querySelector(this.CART_ERROR_SELECTOR);
    if (btn) btn.disabled = true;
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    }
  }

  clearCartError() {
    const errorEl = document.querySelector(this.CART_ERROR_SELECTOR);
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
    this.updateButtonState();
  }

  addToCart() {
    let bls = document.querySelectorAll(this.STEP_SELECTOR+'.'+this.ERROR_CLASS);
    bls.forEach((bl) => {
      bl.classList.remove(this.ERROR_CLASS);
    });
    if (this.steps['1'].product_id === null || this.steps['2'].product_id === null || this.steps['3'].product_id === null || this.steps['4'].selected === null) {
      if (this.steps['1'].product_id === null) {
        let bl = document.querySelector(this.STEP_SELECTOR+this.STEP_SELECTOR+'-1');
        bl.classList.add(this.ERROR_CLASS);
      }
      if (this.steps['2'].product_id === null) {
        let bl = document.querySelector(this.STEP_SELECTOR+this.STEP_SELECTOR+'-2');
        bl.classList.add(this.ERROR_CLASS);
      }
      if (this.steps['3'].product_id === null) {
        let bl = document.querySelector(this.STEP_SELECTOR+this.STEP_SELECTOR+'-3');
        bl.classList.add(this.ERROR_CLASS);
      }
      if (this.steps['4'].selected === null) {
        let bl = document.querySelector(this.STEP_SELECTOR+this.STEP_SELECTOR+'-4');
        bl.classList.add(this.ERROR_CLASS);
      }
      console.error('Not all products selected');
      return;
    }

    let formData = {
      'items': [
        {
          'id': this.steps['1'].variant_id,
          'quantity': 1
        },
        {
          'id': this.steps['2'].variant_id,
          ...(this.steps['2'].subscription && { 'selling_plan': this.steps['2'].subscription }),
          'quantity': 1
        },
        {
          'id': this.steps['3'].variant_id,
          ...(this.steps['3'].subscription && { 'selling_plan': this.steps['3'].subscription }),
          'quantity': 1
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json().then(data => ({ ok: response.ok, data }));
    })
    .then(({ ok, data }) => {
      if (!ok) {
        const message = data.description || data.message || 'Something went wrong. Please try again.';
        this.showCartError(message);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      this.showCartError('Something went wrong. Please try again.');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.customBundle = new customBundle();
});